
import React from "react"
const XSightTopics = () => {

    return (

        <div id={"XSight Topics"}>
            <h3>XSight Topics</h3>
            <p>
                Users now have the ability to create an XSight topic within Snap and showcase the data from the Snap app on the XSight Live View dashboard.
            </p>
            <p>
                To create a new topic, follow these steps:
            </p>
            <ol>
                <li>Navigate to the Data Connection Rule section.</li>
                <br />
                <li>Proceed to the XSight Live View Topic area.</li>
                <br />
                <li>Click on the New Topic button.</li>
                <br />
                <li>Provide a name for the topic and click Create.</li>
                <br />
                <li>This action will result in the creation of a new XSight topic.</li>
            </ol>
            <p>
                If the Snap application incorporates an XSight topic, the XSight Topic category will appear in Blockly. 
                The blocks in this category can be used to retrieve and change values associated with XSight topics.
                <div className={'imageContainer'}>
                    <img src="/images/XSightTopics.PNG" alt="XSight Topics" />
                </div>
            </p>
        </div>

    );


}

export default XSightTopics; 